<template>
  <!-- 定时隐患排查和隐患排查任务的基本信息，一个组件，里面有区分输入框或者下拉框的情况，全凭后端返回的结构是字典的code还是翻译后的中文 -->
  <el-form ref="form" label-width="130px" :model="pointInfo">
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业活动名称" prop="jobActivityName">
          <el-input
            v-model="pointInfo.jobActivityName"
            placeholder="请输入作业活动名称"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业类型" prop="jobType">
          <el-input
            v-if="!pointInfo.jobTypeStr"
            v-model="pointInfo.jobType"
            placeholder="请输入作业类型"
            clearable
            class="w-full"
            :disabled="disabled"
          ></el-input>
          <el-select
            v-if="pointInfo.jobTypeStr"
            v-model="pointInfo.jobTypeStr"
            size="small"
            class="w-full"
            placeholder="请选择作业类型"
            :disabled="disabled"
            clearable
          >
            <el-option
              v-for="item in jobTypeList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="作业编号" prop="jobActivityNumber">
          <el-input
            v-model="pointInfo.jobActivityNumber"
            placeholder="请输入作业编号"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查周期" prop="inspectionCycle">
          <el-input
            v-model="unitCycleListMap"
            placeholder="请输入排查周期"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
        <el-form-item label="排查类型" prop="inspectionType">
          <el-select
            v-model="pointInfo.inspectionType"
            size="small"
            class="w-full"
            placeholder="请选择排查类型"
            :disabled="disabled"
            clearable
          >
            <el-option
              v-for="item in checkTypeList"
              :key="item.value"
              :label="item.displayName"
              :value="Number(item.code)"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="作业步骤" prop="jobSteps">
          <el-input
            type="textarea"
            v-model="pointInfo.jobSteps"
            placeholder="请输入作业步骤"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="危险源或潜在事件" prop="hiddenEvent">
          <el-input
            type="textarea"
            v-model="pointInfo.hiddenEvent"
            placeholder="请输入危险源或潜在事件"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
        <el-form-item label="隐患排查内容" prop="troubleshootingContent">
          <el-input
            type="textarea"
            v-model="pointInfo.troubleshootingContent"
            placeholder="请输入隐患排查内容"
            clearable
            :disabled="disabled"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
import utils from '@/components/safety/enumField/utils'

export default {
  name: 'plantask-job-form',
  props: {
    currentRow: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      unitCycleList: [],
      checkTypeList: [],
      pointInfo: {
        jobActivityName: null,
        jobType: null,
        jobActivityNumber: null,
        inspectionCycle: null,
        jobSteps: null,
        unitCycle: null,
        troubleshootingContent: null,
        inspectionType: null,
        hiddenEvent: '',
        jobTypeStr: null,
      },
      jobTypeList: [],
      areaList: [],
      jobActivityFrequencyList: [],
      jobActivityTypeList: [],
      deviceList: [],
      disabled: true,
    }
  },
  computed: {
    // 排查周期
    unitCycleListMap() {
      const name =
        this.unitCycleList.find((i) => {
          // eslint-disable-next-line eqeqeq
          return i.code == this.pointInfo.unitCycle
        })?.displayName || ''
      return !_.isNil(this.pointInfo.inspectionCycle)
        ? `${this.pointInfo.inspectionCycle}${name}`
        : null
    },
  },
  methods: {
    async getPointInfo() {
      const {
        jobActivityName,
        jobType,
        jobActivityNumber,
        inspectionCycle,
        jobSteps,
        troubleshootingContent,
        inspectionType,
        hiddenEvent,
        unitCycle,
        jobTypeStr,
      } = this.currentRow
      this.pointInfo = {
        jobActivityName,
        jobType,
        jobActivityNumber,
        inspectionCycle,
        jobSteps,
        troubleshootingContent,
        inspectionType,
        hiddenEvent,
        unitCycle,
        jobTypeStr,
      }
    },
  },
  mounted() {
    utils.getDataCategory(
      [
        'DoublePreventionManagement.DataCategory.UnitCycle',
        'DoublePreventionManagement.DataCategory.CheckType',
        'DoublePreventionManagement.DataCategory.JobActivityType',
      ],
      ['unitCycleList', 'checkTypeList', 'jobTypeList'],
      this
    )
    // 获取风险点基本信息
    this.getPointInfo()
  },
}
</script>

<style lang="scss" scoped></style>
